import React, { Component } from "react";
import moment from "moment";
import PrintTable from '../../../../../../CommonComponents/PrintTable/PrintTable';
import {getColumnLength} from '../../../../../../utils/commonUtil';

export default class ExchangeSelectPrint extends Component {
  constructor(props) {
    super(props);
    this.state = {
      dataSource: [],
      columns: []
    };
  }

  componentDidMount() {
    this.setState({ dataSource: [], columns: [] }, () => {
      this.createRowAndColumns(this.props);
    });
  }

  componentWillReceiveProps(nextProps) {
    this.setState({ dataSource: [], columns: [] }, () => {
      this.createRowAndColumns(nextProps);
    });
  }
  createRowAndColumns(props) {
    let dataSource = this.state.dataSource;
    if (props.selectedTabs == "1") {
      props.data.map(item => {
        let temp = {
          enteredDate:
            item.exchangeStartDate == null ? (
              <>&mdash;</>
            ) : (
              moment(
                moment.tz(item.exchangeStartDate, "America/New_York")
              ).format("L")
            ),
          exchangetype:
            item.exchangetype == null ? <>&mdash;</> : item.exchangetype,
          tradeDate:
            item.tradeDate == null ? (
              <>&mdash;</>
            ) : (
              moment(moment.tz(item.tradeDate, "America/New_York")).format("L")
            ),
          allocationType:
            item.allocationType == "" ? (
              <>&mdash;</>
            ) : (
              <>{item.allocationType}</>
            ),
          status:
            item.status.extDescription == null ? (
              <>&mdash;</>
            ) : (
              item.status.extDescription
            ),
          isRecurring: item.isRecurring
        };
        dataSource.push(temp);
      });
      this.setState({
        dataSource: dataSource,
        columns: [
          {
            title: "Entered Date",
            dataIndex: "enteredDate",
            key: "enteredDate"
          },
          {
            title: "Exchange Type",
            dataIndex: "exchangetype",
            key: "exchangetype"
          },
          {
            title: "Trade Date",
            dataIndex: "tradeDate",
            key: "tradeDate"
          },
          {
            title: "Allocation Type",
            dataIndex: "allocationType",
            key: function(allocationType) {
              return allocationType.allocationType.toLowerCase();
            }
          },
          {
            title: "Status",
            dataIndex: "status",
            key: "status"
          },
          {
            title: "",
            dataIndex: "isRecurring",
            key: "isRecurring"
          }
        ]
      });
    } else {
      props.data.map(item => {
        let temp = {
          exchangeCreateDate:
            item.exchangeCreateDate == null ? (
              <>&mdash;</>
            ) : (
            
              moment(moment.tz(item.exchangeCreateDate, "America/New_York")).format("L")
              
            ),
          allocationType:
            item.allocationType == "" ? <>&mdash;</> : item.allocationType,
          frequency: item.frequency == null ? <>&mdash;</> : item.frequency,
          nextScheduledExchangeDated: item.nextScheduledExchangeDate ? (
            moment(moment.tz(item.nextScheduledExchangeDate, "America/New_York")).format("L")
          ) : (
            <>&mdash;</>
          ),
          noOfExchangesRemaining:
            item.noOfExchangesRemaining == null ? (
              <>&mdash;</>
            ) : item.noOfExchangesRemaining < 10 ? (
              <>0{item.noOfExchangesRemaining}</>
            ) : (
              item.noOfExchangesRemaining
            ),
          status: item.status == null ? <>&mdash;</> : item.status
        };
        dataSource.push(temp);
      });
      this.setState({
        dataSource: dataSource,
        columns: [
          {
            title: "Entered Date",
            dataIndex: "exchangeCreateDate",
            key: "exchangeCreateDate"
          },
          {
            title: "Allocation Type",
            dataIndex: "allocationType",
            key: function(allocationType) {
              if (allocationType.allocationType) {
                return allocationType.toLowerCase();
              } else {
                return "-";
              }
            }
          },
          {
            title: "Frequency",
            dataIndex: "frequency",
            key: "frequency"
          },
          {
            title: "Next Scheduled Date",
            dataIndex: "nextScheduledExchangeDated",
            key: "nextScheduledExchangeDated"
          },
          {
            title: "Number of Remaining Exchanges",
            dataIndex: "noOfExchangesRemaining",
            key: "noOfExchangesRemaining"
          },
          {
            title: "Status",
            dataIndex: "status",
            key: "status"
          }
        ]
      });
    }
  }
  render() {
    const {hasIcons = false} = this.props;
    return (
        <PrintTable
        dataSource={this.state.dataSource}
        columns={this.state.columns}
        pagination={false}
        hasIcons={hasIcons}
        width = {getColumnLength(this.state.columns.length)}
      />
    );
  }
}
